import { ComparisonOperators, FovFieldTypes, FovNodeTypes, FovPageType, FovErrorType, FovErrorOption, FovErrorExperience, } from '@contentsquare/fov-constants';
// ANY PAGE
/**********JS*****************/
// User who visited any page and experienced any JS error
const anyJSErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyJSErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            field: 'error:type',
            operator: 'exists',
            value: null,
            nodeType: 'filter',
        },
    },
    nodeType: 'filter',
};
// Users who visited any page and havent experienced any JS error
const anyJSErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyJSErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                field: 'error:type',
                operator: 'exists',
                value: null,
                nodeType: 'filter',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
// User who visited any page and experienced a named JS error that contains 'toto'
const namedJSErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorMessage: 'toto',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedJSErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            field: 'error:message',
            operator: 'matches_regex',
            value: '(?i)(.*toto.*)',
            nodeType: 'filter',
        },
    },
    nodeType: 'filter',
};
// User who visited any page and havent experienced a named JS error that contains 'toto'
const namedJSErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorMessage: 'toto',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedJSErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                field: 'error:message',
                operator: 'matches_regex',
                value: '(?i)(.*toto.*)',
                nodeType: 'filter',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
// User who visited any page and experienced an exact JS error with details ...
const exactJSErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        errorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        errorFileName: 'index.js',
        errorLineNumber: 3,
        errorColumnNumber: 3,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactJSErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'error:message',
                    operator: 'equals',
                    value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                    nodeType: 'filter',
                },
                {
                    field: 'error:filename',
                    operator: 'equals',
                    value: 'index.js',
                    nodeType: 'filter',
                },
                {
                    field: 'error:lineNumber',
                    operator: 'equals',
                    value: '3',
                    nodeType: 'filter',
                },
                {
                    field: 'error:colNumber',
                    operator: 'equals',
                    value: '3',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// User who visited any page and havent experienced an exact JS error with details ...
const exactJSErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        errorFileName: 'index.js',
        errorLineNumber: 3,
        errorColumnNumber: 3,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactJSErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                children: [
                    {
                        field: 'error:message',
                        operator: 'equals',
                        value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                        nodeType: 'filter',
                    },
                    {
                        field: 'error:filename',
                        operator: 'equals',
                        value: 'index.js',
                        nodeType: 'filter',
                    },
                    {
                        field: 'error:lineNumber',
                        operator: 'equals',
                        value: '3',
                        nodeType: 'filter',
                    },
                    {
                        field: 'error:colNumber',
                        operator: 'equals',
                        value: '3',
                        nodeType: 'filter',
                    },
                ],
                nodeType: 'AND',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
// User who visited any page and experienced a grouped JS error 1234
const groupedJSErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedJSErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            field: 'error:groupId',
            operator: 'equals',
            value: '1234',
            nodeType: 'filter',
        },
    },
    nodeType: 'filter',
};
// User who visited any page and havent experienced a grouped JS error 1234
const groupedJSErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedJSErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                field: 'error:groupId',
                operator: 'equals',
                value: '1234',
                nodeType: 'filter',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
// SPECIFIC PAGE
/**********JS*****************/
// Users who visited a specific page page1 and experienced any JS error
const anyJSErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyJSErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'error:type',
                    operator: 'exists',
                    value: null,
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    nodeType: 'filter',
                    operator: 'equals',
                    value: '/page1',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havent experienced any JS error
const anyJSErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: undefined,
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyJSErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: { field: 'page:path', operator: 'equals', value: '/page1', nodeType: 'filter' },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            { field: 'page:path', operator: 'equals', value: '/page1', nodeType: 'filter' },
                            { field: 'error:type', operator: 'exists', value: null, nodeType: 'filter' },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific page page1 and experienced a named JS error that contains 'toto'
const namedJSErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorMessage: 'toto',
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: undefined,
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedJSErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'error:message',
                    operator: 'matches_regex',
                    value: '(?i)(.*toto.*)',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havn't experienced a named JS error that contains 'toto'
const namedJSErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorMessage: 'toto',
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: undefined,
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedJSErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                field: 'page:path',
                                operator: 'equals',
                                value: '/page1',
                                nodeType: 'filter',
                            },
                            {
                                field: 'error:message',
                                operator: 'matches_regex',
                                value: '(?i)(.*toto.*)',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific page page1 and experienced an exact JS error with details ...
const exactJSErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        errorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        errorFileName: 'index.js',
        errorLineNumber: 3,
        errorColumnNumber: 3,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactJSErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    children: [
                        {
                            field: 'error:message',
                            operator: 'equals',
                            value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                            nodeType: 'filter',
                        },
                        {
                            field: 'error:filename',
                            operator: 'equals',
                            value: 'index.js',
                            nodeType: 'filter',
                        },
                        {
                            field: 'error:lineNumber',
                            operator: 'equals',
                            value: '3',
                            nodeType: 'filter',
                        },
                        {
                            field: 'error:colNumber',
                            operator: 'equals',
                            value: '3',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havent experienced an exact JS error with details ...
const exactJSErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        errorFileName: 'index.js',
        errorLineNumber: 3,
        errorColumnNumber: 3,
        apiErrorURL: undefined,
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactJSErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                field: 'page:path',
                                operator: 'equals',
                                value: '/page1',
                                nodeType: 'filter',
                            },
                            {
                                children: [
                                    {
                                        field: 'error:message',
                                        operator: 'equals',
                                        value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'error:filename',
                                        operator: 'equals',
                                        value: 'index.js',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'error:lineNumber',
                                        operator: 'equals',
                                        value: '3',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'error:colNumber',
                                        operator: 'equals',
                                        value: '3',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific page page1 and experienced a grouped JS error 1234
const groupedJSErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedJSErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'error:groupId',
                    operator: 'equals',
                    value: '1234',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havent experienced a grouped JS error 1234
const groupedJSErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedJSErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                field: 'page:path',
                                operator: 'equals',
                                value: '/page1',
                                nodeType: 'filter',
                            },
                            {
                                field: 'error:groupId',
                                operator: 'equals',
                                value: '1234',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
/******************************************************************** */
// SPECIFIC URL
/**********JS*****************/
// Users who visited a specific URL and experienced any JS error
const anyJSErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyJSErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'page:host',
                    operator: 'equals',
                    value: 'www.ray-ban.com',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'page:query',
                    operator: 'equals',
                    value: '',
                    nodeType: 'filter',
                },
                {
                    field: 'error:type',
                    operator: 'exists',
                    value: null,
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific URL and havent experienced any JS error
const anyJSErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorMessage: undefined,
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: undefined,
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyJSErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                field: 'error:type',
                                operator: 'exists',
                                value: null,
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific URL and experienced a named JS error that contains 'toto'
const namedJSErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorMessage: 'toto',
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: undefined,
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedJSErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'page:host',
                    operator: 'equals',
                    value: 'www.ray-ban.com',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'page:query',
                    operator: 'equals',
                    value: '',
                    nodeType: 'filter',
                },
                {
                    field: 'error:message',
                    operator: 'matches_regex',
                    value: '(?i)(.*toto.*)',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific URL and havent experienced a named JS error that contains 'toto'
const namedJSErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorMessage: 'toto',
        errorFileName: undefined,
        errorLineNumber: undefined,
        errorColumnNumber: undefined,
        apiErrorURL: undefined,
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedJSErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                field: 'error:message',
                                operator: 'matches_regex',
                                value: '(?i)(.*toto.*)',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// User who visited a specific URL and experienced an exact JS error with details ...
const exactJSErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        errorFileName: 'index.js',
        errorLineNumber: 3,
        errorColumnNumber: 3,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactJSErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'page:host',
                    operator: 'equals',
                    value: 'www.ray-ban.com',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'page:query',
                    operator: 'equals',
                    value: '',
                    nodeType: 'filter',
                },
                {
                    field: 'error:message',
                    operator: 'equals',
                    value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                    nodeType: 'filter',
                },
                {
                    field: 'error:filename',
                    operator: 'equals',
                    value: 'index.js',
                    nodeType: 'filter',
                },
                {
                    field: 'error:lineNumber',
                    operator: 'equals',
                    value: '3',
                    nodeType: 'filter',
                },
                {
                    field: 'error:colNumber',
                    operator: 'equals',
                    value: '3',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// User who visited a specific URL and havent experienced an exact JS error with details ...
const exactJSErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        errorFileName: 'index.js',
        errorLineNumber: 3,
        errorColumnNumber: 3,
        apiErrorURL: undefined,
        apiErrorMethod: undefined,
        apiErrorStatusCode: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactJSErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                children: [
                                    {
                                        field: 'error:message',
                                        operator: 'equals',
                                        value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'error:filename',
                                        operator: 'equals',
                                        value: 'index.js',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'error:lineNumber',
                                        operator: 'equals',
                                        value: '3',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'error:colNumber',
                                        operator: 'equals',
                                        value: '3',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// User who visited a specific URL and experienced an exact JS error with details ...
const groupedJSErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedJSErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'page:host',
                    operator: 'equals',
                    value: 'www.ray-ban.com',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'page:query',
                    operator: 'equals',
                    value: '',
                    nodeType: 'filter',
                },
                {
                    field: 'error:groupId',
                    operator: 'equals',
                    value: '1234',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// User who visited a specific URL and havent experienced an exact JS error with details ...
const groupedJSErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedJSErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                field: 'error:groupId',
                                operator: 'equals',
                                value: '1234',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
const anyJSErrorOnAnyPageWithMultiClicks = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        errorHasMultipleClicks: true,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyJSErrorOnAnyPageWithMultiClicks = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                field: 'error:type',
                operator: 'exists',
                value: null,
                nodeType: 'filter',
                params: { errorHasMultipleClicks: true },
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
const anyJSErrorOnAnyPageWithoutMultiClicks = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        errorHasMultipleClicks: false,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyJSErrorOnAnyPageWithoutMultiClicks = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                field: 'error:type',
                operator: 'exists',
                value: null,
                nodeType: 'filter',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
const exactJSErrorWithMultiClicks = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        errorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        errorFileName: 'index.js',
        errorLineNumber: 3,
        errorColumnNumber: 3,
        errorHasMultipleClicks: true,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactJSErrorWithMultiClicks = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'error:message',
                    operator: 'equals',
                    value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                    nodeType: 'filter',
                    params: {
                        errorHasMultipleClicks: true,
                    },
                },
                {
                    field: 'error:filename',
                    operator: 'equals',
                    value: 'index.js',
                    nodeType: 'filter',
                },
                {
                    field: 'error:lineNumber',
                    operator: 'equals',
                    value: '3',
                    nodeType: 'filter',
                },
                {
                    field: 'error:colNumber',
                    operator: 'equals',
                    value: '3',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
const exactJSErrorWithoutiClicks = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        errorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        errorFileName: 'index.js',
        errorLineNumber: 3,
        errorColumnNumber: 3,
        errorHasMultipleClicks: false,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactJSErrorWithoutMultiClicks = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'error:message',
                    operator: 'equals',
                    value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                    nodeType: 'filter',
                },
                {
                    field: 'error:filename',
                    operator: 'equals',
                    value: 'index.js',
                    nodeType: 'filter',
                },
                {
                    field: 'error:lineNumber',
                    operator: 'equals',
                    value: '3',
                    nodeType: 'filter',
                },
                {
                    field: 'error:colNumber',
                    operator: 'equals',
                    value: '3',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
const groupedJSErrorWithMultiClicks = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorGroupId: '1234',
        errorHasMultipleClicks: true,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedJSErrorWithMultiClicks = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            field: 'error:groupId',
            operator: 'equals',
            value: '1234',
            nodeType: 'filter',
            params: {
                errorHasMultipleClicks: true,
            },
        },
    },
    nodeType: 'filter',
};
const groupedJSErrorWithoutMultiClicks = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.JS,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorGroupId: '1234',
        errorHasMultipleClicks: false,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedJSErrorWithoutMultiClicks = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            field: 'error:groupId',
            operator: 'equals',
            value: '1234',
            nodeType: 'filter',
        },
    },
    nodeType: 'filter',
};
export const fovErrorSamplesJS = {
    anyJSErrorOnAnyPageInclude,
    expandedAnyJSErrorOnAnyPageInclude,
    anyJSErrorOnAnyPageExclude,
    expandedAnyJSErrorOnAnyPageExclude,
    namedJSErrorOnAnyPageInclude,
    expandedNamedJSErrorOnAnyPageInclude,
    namedJSErrorOnAnyPageExclude,
    expandedNamedJSErrorOnAnyPageExclude,
    exactJSErrorOnAnyPageInclude,
    expandedExactJSErrorOnAnyPageInclude,
    exactJSErrorOnAnyPageExclude,
    expandedExactJSErrorOnAnyPageExclude,
    groupedJSErrorOnAnyPageInclude,
    expandedGroupedJSErrorOnAnyPageInclude,
    groupedJSErrorOnAnyPageExclude,
    expandedGroupedJSErrorOnAnyPageExclude,
    anyJSErrorOnSpecificPageInclude,
    expandedAnyJSErrorOnSpecificPageInclude,
    anyJSErrorOnSpecificPageExclude,
    expandedAnyJSErrorOnSpecificPageExclude,
    namedJSErrorOnSpecificPageInclude,
    expandedNamedJSErrorOnSpecificPageInclude,
    namedJSErrorOnSpecificPageExclude,
    expandedNamedJSErrorOnSpecificPageExclude,
    exactJSErrorOnSpecificPageInclude,
    expandedExactJSErrorOnSpecificPageInclude,
    exactJSErrorOnSpecificPageExclude,
    expandedExactJSErrorOnSpecificPageExclude,
    groupedJSErrorOnSpecificPageInclude,
    expandedGroupedJSErrorOnSpecificPageInclude,
    groupedJSErrorOnSpecificPageExclude,
    expandedGroupedJSErrorOnSpecificPageExclude,
    anyJSErrorOnSpecificURLInclude,
    expandedAnyJSErrorOnSpecificURLInclude,
    anyJSErrorOnSpecificURLExclude,
    expandedAnyJSErrorOnSpecificURLExclude,
    namedJSErrorOnSpecificURLInclude,
    expandedNamedJSErrorOnSpecificURLInclude,
    namedJSErrorOnSpecificURLExclude,
    expandedNamedJSErrorOnSpecificURLExclude,
    exactJSErrorOnSpecificURLInclude,
    expandedExactJSErrorOnSpecificURLInclude,
    exactJSErrorOnSpecificURLExclude,
    expandedExactJSErrorOnSpecificURLExclude,
    groupedJSErrorOnSpecificURLInclude,
    expandedGroupedJSErrorOnSpecificURLInclude,
    groupedJSErrorOnSpecificURLExclude,
    expandedGroupedJSErrorOnSpecificURLExclude,
    anyJSErrorOnAnyPageWithMultiClicks,
    expandedAnyJSErrorOnAnyPageWithMultiClicks,
    anyJSErrorOnAnyPageWithoutMultiClicks,
    expandedAnyJSErrorOnAnyPageWithoutMultiClicks,
    exactJSErrorWithMultiClicks,
    expandedExactJSErrorWithMultiClicks,
    exactJSErrorWithoutiClicks,
    expandedExactJSErrorWithoutMultiClicks,
    groupedJSErrorWithMultiClicks,
    expandedGroupedJSErrorWithMultiClicks,
    groupedJSErrorWithoutMultiClicks,
    expandedGroupedJSErrorWithoutMultiClicks,
};
//# sourceMappingURL=fov-error.samples-js.js.map